import React, { useRef } from "react";
import PropTypes from "prop-types";
import CustomInput from "components/CustomInput/CustomInput";
import Button from "components/CustomButtons/Button.js";
import Swal from "sweetalert2";

const BodyHtmlInput = ({ value, onChange, labelText = "Body HTML" }) => {
  const fileInput = useRef(null);

  const handleTextChanged = e => onChange(e.target.value);

  const handleFileChanged = e => {
    const file = e.target.files[0];
    e.target.value = "";
    if (!file) return;

    if (!/\.html?$/i.test(file.name)) {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Please attach a .html file!"
      });
      return;
    }

    const reader = new FileReader();
    reader.onload = () => onChange(reader.result);
    reader.readAsText(file);
  };

  return (
    <div>
      <CustomInput
        labelText={labelText}
        formControlProps={{
          fullWidth: true
        }}
        inputProps={{
          multiline: true,
          rows: 12,
          onChange: handleTextChanged,
          value: value ?? ""
        }}
      />
      <input
        type="file"
        accept=".html,.htm,text/html"
        ref={fileInput}
        style={{ display: "none" }}
        onChange={handleFileChanged}
      />
      <Button
        color="info"
        type="button"
        onClick={() => fileInput.current.click()}
      >
        Attach HTML File
      </Button>
    </div>
  );
};

export default BodyHtmlInput;

BodyHtmlInput.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func,
  labelText: PropTypes.string
};
